module.exports = __webpack_public_path__ + "img/procrastinationthumb.ac9c0d58.gif";